import { Outlet } from 'react-router-dom'

import { useMeQuery } from '../store/api'
import { CompanyStatusCheckView } from '../views/dashboard/company-status-check-view'

export default function CompanyStatusCheck() {
  const { data } = useMeQuery()

  if (data && data.enabled) {
    return <Outlet />
  } else {
    return <CompanyStatusCheckView />
  }
}
